export default "__VITE_ASSET__DVQORgMo__"